import {
  Component,
  OnInit,
  Input,
  OnDestroy,
  AfterViewInit,
  ViewChild,
  TemplateRef,
  Output,
  EventEmitter,
} from "@angular/core";
import { Subject, fromEvent } from "rxjs";
import * as moment from "moment";
import _ from "lodash";
import { takeUntil } from "rxjs/operators";
import { NzModalService } from "ng-zorro-antd/modal";
import { TranslateService } from "@root/shared/service/translate.service";
import { DateService } from "@root/shared/service/date.service";

interface Item {
  type: "day" | "month" | "quarter" | "year";
  range: Array<string>;
}

@Component({
  selector: "host-month-search",
  templateUrl: "./month-search.component.html",
  styleUrls: ["./month-search.component.scss"],
})
export class MonthSearchComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() from: "note" | "statistics" = "statistics";
  @Input() defaultValue: Item = null;
  @Input() showWidth = null;
  @Output() onSelect = new EventEmitter<Item>(); // 选中后的回调

  @ViewChild("monthSelectPanel")
  monthSelectPanel: TemplateRef<any>;
  @ViewChild("monthSelectModal") monthSelectModal;

  isOpen = false;
  time: string = null;
  leftYear: string;
  rightYear: string;
  startDate: string = null;
  endDate: string = null;
  firstChoose = true;
  monthChoice = [
    this.translateService.syncGet("word.January"),
    this.translateService.syncGet("word.February"),
    this.translateService.syncGet("word.March"),
    this.translateService.syncGet("word.April"),
    this.translateService.syncGet("word.May"),
    this.translateService.syncGet("word.June"),
    this.translateService.syncGet("word.July"),
    this.translateService.syncGet("word.August"),
    this.translateService.syncGet("word.September"),
    this.translateService.syncGet("word.October"),
    this.translateService.syncGet("word.November"),
    this.translateService.syncGet("word.December"),
  ];
  leftMonths = [];
  rightMonths = [];
  monthModal;

  get statisticsStyle() {
    return this.from === "statistics";
  }

  get noteStyle() {
    return this.from === "note";
  }

  private destroy$ = new Subject();

  constructor(
    private modalService: NzModalService,
    private translateService: TranslateService,
    private dateService: DateService
  ) {}

  ngOnInit() {
    this.formatData();
  }

  ngAfterViewInit() {
    fromEvent(document, "click")
      .pipe(takeUntil(this.destroy$))
      .subscribe((event: MouseEvent) => {
        const path =
          _.get(event, "path") || (event.composedPath && event.composedPath());
        let flag = false;
        let i = 0;
        _.forEach(path, (p) => {
          i++;
          if (i > 10) {
            return;
          }
          const className = _.get(p, "className");
          const temp = _.split(className, " ");
          if (
            temp.indexOf("template") !== -1 ||
            temp.indexOf("select") !== -1
          ) {
            flag = true;
            return;
          }
        });
        if (!flag) {
          if (this.monthModal) {
            this.monthModal.destroy();
          }
          this.isOpen = false;
        }
      });
  }

  displayMenu() {
    const modalStyle = {
      position: "absolute",
      left: this.monthSelectModal.nativeElement.parentNode.getBoundingClientRect()
        .left,
      top:
        this.monthSelectModal.nativeElement.parentNode.getBoundingClientRect()
          .top + 36,
    };
    if (!this.isOpen) {
      this.monthModal = this.modalService.create({
        nzTitle: null,
        nzContent: this.monthSelectPanel,
        nzFooter: null,
        nzWidth: 554,
        nzMask: false,
        nzClosable: false,
        nzStyle: modalStyle,
        nzWrapClassName: "overlap-modal",
      });
    }
    this.isOpen = !this.isOpen;
  }

  formatData() {
    const year = moment().format("YYYY");
    const start = this.dateService.format(moment().startOf("year"), ["YM"]);
    const end = this.dateService.format(moment(), ["YM"]);
    const endDate = moment().endOf("month").format("YYYY-MM-DD");
    this.time = this.from === "statistics" ? `${start} ~ ${end}` : null;
    this.rightYear = moment().format("YYYY");
    this.leftYear = moment(this.rightYear, "YYYY")
      .subtract(1, "years")
      .format("YYYY");
    this.fomatMonths();
    if (this.from !== "note") {
      this.onSelect.emit({
        type: "month",
        range: [`${year}-01-01`, endDate],
      });
    }
  }

  fomatMonths() {
    this.initMonths(0);
    this.initMonths(1);
  }

  initMonths(index) {
    const year = moment().format("YYYY");
    const start = `${year}.01`;
    const end = moment().format("YYYY.MM");
    let i = 1;
    const whichYear = index === 0 ? this.leftYear : this.rightYear;
    _.forEach(this.monthChoice, (item) => {
      const month = `${whichYear}.${i}`;
      let firstCheckedMonth;
      let secondCheckedMonth;
      let inRangeMonth;
      if (this.from !== "note") {
        if (this.startDate && this.endDate) {
          firstCheckedMonth =
            moment(month, "YYYY-MM").diff(
              moment(this.startDate, "YYYY-MM"),
              "months"
            ) === 0
              ? true
              : false;
          secondCheckedMonth =
            moment(month, "YYYY-MM").diff(
              moment(this.endDate, "YYYY-MM"),
              "months"
            ) === 0
              ? true
              : false;
          inRangeMonth =
            moment(month, "YYYY-MM").diff(
              moment(this.startDate, "YYYY-MM"),
              "days"
            ) > 0 &&
            moment(month, "YYYY-MM").diff(
              moment(this.endDate, "YYYY-MM"),
              "days"
            ) < 0
              ? true
              : false;
        } else if (this.startDate && !this.endDate) {
          firstCheckedMonth =
            moment(month, "YYYY-MM").diff(
              moment(this.startDate, "YYYY-MM"),
              "months"
            ) === 0
              ? true
              : false;
          secondCheckedMonth = false;
        } else {
          firstCheckedMonth =
            moment(month, "YYYY-MM").diff(
              moment(start, "YYYY-MM"),
              "months"
            ) === 0
              ? true
              : false;
          secondCheckedMonth =
            moment(month, "YYYY-MM").diff(moment(end, "YYYY-MM"), "months") ===
            0
              ? true
              : false;
          inRangeMonth =
            moment(month, "YYYY-MM").diff(moment(start, "YYYY-MM"), "days") >
              0 &&
            moment(month, "YYYY-MM").diff(moment(end, "YYYY-MM"), "days") < 0
              ? true
              : false;
        }
      }

      if (this.from === "note") {
        firstCheckedMonth = false;
        secondCheckedMonth = false;
      }
      if (!index) {
        this.leftMonths.push({
          title: item,
          year: this.leftYear,
          checked: firstCheckedMonth ? true : secondCheckedMonth ? true : false,
          range: inRangeMonth ? true : false,
          index: i++,
        });
      } else {
        this.rightMonths.push({
          title: item,
          year: this.rightYear,
          checked: firstCheckedMonth ? true : secondCheckedMonth ? true : false,
          range: inRangeMonth ? true : false,
          index: i++,
        });
      }
    });
  }

  changeYear(method) {
    // position:0代表左侧年份，1代表右侧年份，method:0代表减运算，1代表加运算
    if (method === 0) {
      this.leftYear = moment(this.leftYear, "YYYY")
        .subtract(1, "years")
        .format("YYYY");
      this.rightYear = moment(this.rightYear, "YYYY")
        .subtract(1, "years")
        .format("YYYY");
    } else {
      this.leftYear = moment(this.leftYear, "YYYY")
        .add(1, "years")
        .format("YYYY");
      this.rightYear = moment(this.rightYear, "YYYY")
        .add(1, "years")
        .format("YYYY");
    }
    this.leftMonths = [];
    this.rightMonths = [];
    this.fomatMonths();
  }

  chooseMonth(month, index) {
    const monthNum = index + 1 > 9 ? `${index + 1}` : `0${index + 1}`;
    if (this.firstChoose) {
      this.startDate = `${month.year}-${monthNum}-01`;
      this.clearMonth();
    } else {
      this.endDate = `${month.year}-${monthNum}-01`;
      const monthLen = moment(this.endDate, "YYYY-MM").diff(
        moment(this.startDate, "YYYY-MM"),
        "months"
      );
      console.log(monthLen);
      const diff = monthLen > 0 ? true : false;
      console.log(diff);
      if (!diff) {
        const temp = this.startDate;
        this.startDate = this.endDate;
        this.endDate = temp;
      }
      const len = Math.abs(monthLen) + 1;
      const noteText =
        len > 1
          ? `${this.dateService.format(this.startDate, [
              "YM",
            ])} ~ ${this.dateService.format(this.endDate, [
              "YM",
            ])} ${this.translateService.syncGet(
              "component.search.total_months",
              {
                monthLen: len,
              }
            )}`
          : `${this.dateService.format(this.startDate, [
              "YM",
            ])} ~ ${this.dateService.format(this.endDate, [
              "YM",
            ])} ${this.translateService.syncGet(
              "component.search.total_month",
              {
                monthLen: len,
              }
            )}`;
      const normalText = `${this.dateService.format(this.startDate, [
        "YM",
      ])} ~ ${this.dateService.format(this.endDate, ["YM"])}`;
      this.time = this.from === "note" ? noteText : normalText;
      const start = moment(this.startDate, "YYYY-MM")
        .startOf("month")
        .format("YYYY-MM-DD");
      const end = moment(this.endDate, "YYYY-MM")
        .add(1, "months")
        .subtract(1, "days")
        .format("YYYY-MM-DD");
      this.onSelect.emit({
        type: "month",
        range: [start, end],
      });
      this.makeMonthInRange(this.leftMonths);
      this.makeMonthInRange(this.rightMonths);
      this.monthModal.destroy();
      this.isOpen = false;
    }
    month.checked = true;
    this.firstChoose = !this.firstChoose;
  }

  makeMonthInRange(monthArray) {
    _.forEach(monthArray, (item) => {
      const inRangeMonth =
        moment(`${item.year}-${item.index}`, "YYYY-MM").diff(
          moment(this.startDate, "YYYY-MM"),
          "days"
        ) > 0 &&
        moment(`${item.year}-${item.index}`, "YYYY-MM").diff(
          moment(this.endDate, "YYYY-MM"),
          "days"
        ) < 0
          ? true
          : false;
      _.assign(item, {
        range: inRangeMonth,
      });
    });
  }

  quickChoose(choice) {
    this.isOpen = false;
    this.monthModal.destroy();
    this.clearMonth();
    this.startDate = "0001.01";
    this.endDate = "0001.01";
    let startDate;
    let endDate;
    const currentYear = moment().format("YYYY");
    switch (choice) {
      case "今年":
        this.time = this.translateService.syncGet("component.search.this_year");
        startDate = `${currentYear}-01-01`;
        if (moment().isAfter(moment(`${currentYear}-06-30`, "YYYY-MM-DD"))) {
          endDate = moment(currentYear, "YYYY")
            .endOf("year")
            .format("YYYY-MM-DD");
        } else {
          endDate = moment().add(6, "months").format("YYYY-MM-DD");
        }
        break;
      case "去年":
        this.time = this.translateService.syncGet("component.search.last_year");
        startDate = `${moment(currentYear, "YYYY")
          .subtract(1, "years")
          .format("YYYY")}-01-01`;
        endDate = moment(currentYear, "YYYY")
          .subtract(1, "days")
          .format("YYYY-MM-DD");
        break;
    }
    this.onSelect.emit({
      type: "month",
      range: [startDate, endDate],
    });
  }

  clearMonth() {
    _.forEach(this.leftMonths, (item) => {
      item.checked = false;
      item.range = false;
    });
    _.forEach(this.rightMonths, (item) => {
      item.checked = false;
      item.range = false;
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
